import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../../public/scss/feedComponent.scss";

import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faShareAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

import * as htmlToImage from 'html-to-image';

// import store from './../store';
import PropTypes from 'prop-types';
import { uploadSharableImageToS3, convertS3ImageToBase64 } from './../../../actions/feedActions';
import { connect } from 'react-redux';
// import { getUserData, logOut } from './../actions/utility';

import lmLogo from "./../../../public/images/logo.png";
import whiteLabelLogo from "./../../../public/images/logoWhiteLabel.png";

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Button,
    Container,
    Row,
    Media,
    Col,
    Card,
    CardTitle,
    CardSubtitle,
    CardBody,
    CardText,
    CardLink,
    Badge,
    Spinner
    // NavLink
} from "reactstrap";

import {
    EmailShareButton,
    EmailIcon,
    FacebookShareButton,
    FacebookIcon,
    // InstapaperShareButton,
    // LineShareButton,
    LinkedinShareButton,
    LinkedinIcon,
    // LivejournalShareButton,
    // MailruShareButton,
    // OKShareButton,
    // PinterestShareButton,
    // PocketShareButton,
    // RedditShareButton,
    // TelegramShareButton,
    // TumblrShareButton,
    TwitterShareButton,
    TwitterIcon,
    // ViberShareButton,
    // VKShareButton,
    WhatsappShareButton,
    WhatsappIcon,
    // WorkplaceShareButton,
  } from "react-share";

class AutoPopulatedFeedResults extends Component {

  constructor(props) {
    super(props);

    this.state = {
        studentInfo : this.props.studentInfo,
        studentProgarms : this.props.studentProgarms,
        topicVideos: this.props.topicVideos,
        programRelatedData: this.props.programRelatedData,
        randomImages: this.props.randomImages,
        topicWorkSheets: this.props.topicWorkSheets,
        bgColor1 : "#000",
        bgColor2 : "#000",
        shareUrl: "",
        generateImageLoader: false,
        isShareIconsVisisble : [],
        binaryUserImage : "",
        waterMarkLogo : window.location.host === "feeds.lincolnmethod.com" ? lmLogo : whiteLabelLogo
        // waterMarkLogo : lmLogo
    };

  }

  componentWillReceiveProps(nextProps, thisProps) {
    if(nextProps.studentInfo){
        this.setState({
            studentInfo: nextProps.studentInfo
        })
    }
    if(nextProps.studentProgarms){
        this.setState({
        studentProgarms: nextProps.studentProgarms
        })
    }
    if(nextProps.topicVideos){
        this.setState({
            topicVideos: nextProps.topicVideos
        })
    }
    if(nextProps.programRelatedData){
        this.setState({
            programRelatedData: nextProps.programRelatedData
        })
    }
    if(nextProps.randomImages){
        this.setState({
            randomImages: nextProps.randomImages
        })
    }
    if(nextProps.topicWorkSheets){
        this.setState({
            topicWorkSheets: nextProps.topicWorkSheets
        })
    }

    if(this.props.uploadedImageData != nextProps.uploadedImageData) {
        if(nextProps.uploadedImageData.key == this.props.key2){
            
            var imagePath = nextProps.uploadedImageData.data.shareImagePath;
            this.setState({
                shareUrl : imagePath
            }, () => {
                var shareShowUpdateArray = this.state.isShareIconsVisisble;
                shareShowUpdateArray[nextProps.uploadedImageData.key] = true;
                this.setState({
                    isShareIconsVisisble : shareShowUpdateArray,
                    generateImageLoader : false
                })
            })
            // console.log(nextProps.uploadedImageData);
        }
    }

    if(this.props.convertedBase64Binary != nextProps.convertedBase64Binary) {
        this.setState({
            binaryUserImage : nextProps.convertedBase64Binary
        }, () => {
            console.log(this.state.binaryUserImage);
        })
    }
    
  }

  
  componentDidMount() {
      
    var randomColor = require('randomcolor');
    var bgColor1 = randomColor();
    var bgColor2 = randomColor();

    this.setState({
        bgColor1 : bgColor1,
        bgColor2 : bgColor2
    })

    var shareShowUpdateArray = this.state.isShareIconsVisisble;
    shareShowUpdateArray[this.props.key2] = false;
    this.setState({
        isShareIconsVisisble : shareShowUpdateArray
    })

    if(this.state.binaryUserImage == "") {

        var studentImage = this.state.studentInfo.image;
        studentImage = studentImage && studentImage != null ? "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/" + studentImage : 'https://info.lincolnmethod.com/wp-content/uploads/2019/12/noimage.png';
        
        this.props.convertS3ImageToBase64(studentImage);
    
    }

  }

  formatDate(date) {
    var newDate = date.split('-');
    newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];

    return newDate;
  }

  createStars = (length, dynamicColor) => {
    let stars = [];

    // Outer loop to create parent
    for (let i = 0; i < length; i++) {
        
        let star = <FontAwesomeIcon className={'star star'+(i+1)} key={i} icon={faStar} size="3x" color={"#fff"} style={{backgroundColor: dynamicColor}} />;

        stars.push(star)
    }
    return stars
  }

  generateImageToShare = (elem) => {

    this.setState({
        generateImageLoader : true
    }, () => {
        console.log(elem);
        var this2 = this;
        htmlToImage.toPng(document.getElementById(elem))
        .then(function (dataUrl) {
            console.log('dataUrl', dataUrl);
            if(dataUrl){
                //uploading the image to s3 which will be shared.
                this2.props.uploadSharableImageToS3(dataUrl, this2.state.studentInfo.id, 0, 0, this2.props.data.testid, this2.props.key2);
            }
        });
    })

    

    // htmlToImage.toJpeg(document.getElementById(elem), { quality: 0.95 })
    // .then(function (dataUrl) {
    //     console.log(dataUrl);
    //     // var link = document.createElement('a');
    //     // link.download = 'my-image-name.jpeg';
    //     // link.href = dataUrl;
    //     // link.click();
    // });
  }

//   loadBase64UserImg = (e) => {
//       console.log(e);

//       var getDataUrl = function (img) {
//         var canvas = document.createElement('canvas')
//         var ctx = canvas.getContext('2d')
        
//         canvas.width = img.width
//         canvas.height = img.height
//         ctx.drawImage(img, 0, 0)
        
//         // If the image is not png, the format
//         // must be specified here
//         return canvas.toDataURL()
//     }

//     var dataUrl = getDataUrl(e.currentTarget);
//     console.log(dataUrl);

//   }


  closeShareButton = (index) => {
    var shareShowUpdateArray = this.state.isShareIconsVisisble;
    shareShowUpdateArray[index] = false;
    this.setState({
        isShareIconsVisisble : shareShowUpdateArray
    })
  }


  render() {

    var feed = this.props.data;
    var key = this.props.key2;
    var studentName = this.state.studentInfo.user_name;

    // const image2base64 = require('image-to-base64');
    // image2base64(studentImage) // you can also to use url
    //     .then(
    //         (response) => {
    //             console.log(response); //cGF0aC90by9maWxlLmpwZw==
    //         }
    //     )
    //     .catch(
    //         (error) => {
    //             console.log(error); //Exepection error....
    //         }
    //     )
    
    // var timeStamp = feed.ts;
    // var splittedTimeStamp = timeStamp.split(" ");
    // var dateTime = this.formatDate(splittedTimeStamp[0]);

    var dateTime = null;
    var programName = this.state.programRelatedData.program_name;
    var chapterName = this.state.programRelatedData.chapter_name;    
    // var bgColor1 = "blue";
    // var bgColor2 = "green";

    var beforeHeight = feed.beforeScore;
    var afterHeight = feed.afterScore;

    var hostName = window.location.host.replace("feeds.", "").replace(".com", "");


    return (
        <Card id={'currentpost' + key} style={{marginBottom: '2vh', border: '1px #ccc solid', textAlign: 'left'}}>

            <CardBody style={{padding : 0}}>
                <Row style={{margin: 0}}>
                    
                    <Col xs={{size: 12}} id={"autoPopulatedPost"+key} className="autoPopulatedPost results"
                        style={{background: "linear-gradient(120deg, "+this.state.bgColor1+", "+this.state.bgColor2+")"}}>
                            
                        {
                            window.location.host === "feeds.lincolnmethod.com" ?
                                <Media className="waterMark" src={this.state.waterMarkLogo} />
                            :
                            window.location.host === "feeds.skillupz.com" ?
                                <Media className="waterMark" src={this.state.waterMarkLogo} />
                            : null
                        }

                        <Row>
                            <Col style={{textAlign: 'center'}} md={{size: 6}}>

                                <div className="candidateImagePost" style={{backgroundImage: 'url('+ this.state.binaryUserImage.binary +')'}}>
                                    {/* <Media src={ studentImage } /> */}
                                </div>
                                <div style={{textAlign: 'left', color: '#fff'}}>
                                    <h5><strong>{ studentName }</strong> took a test <strong>{ feed.testname }</strong></h5>
                                    {
                                        programName && programName != null ?
                                        <p style={{fontSize: '12px', margin: 0}}>
                                            Program: <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: programName}}></span>
                                        </p>
                                        : null
                                    }
                                    {
                                        chapterName && chapterName != null ?
                                        <p style={{fontSize: '12px', margin: 0}}>
                                            Chapter: <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: chapterName}}></span>
                                        </p>
                                        : null
                                    }
                                    {
                                        dateTime ?
                                            <p style={{fontSize: '11px', margin: 0, marginTop: '15px'}}>
                                                on <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: dateTime}}></span>
                                            </p>
                                        : null
                                    }
                                </div>
                            </Col>
                            <Col md={{size: 6}}>
                                <Row className="progressBox">
                                    <Col xs={{size: 6}}>
                                        <div className="progressBar before" style={{background: 'linear-gradient(360deg, #ff0300 0%, #ff0300 '+beforeHeight+'%, #ff0300 '+beforeHeight+'%, #ff0300 100%)', height: "calc(" + beforeHeight + "% - 0px)"}}>
                                            <p className="progressPerc">{feed.beforeScore}<span style={{fontSize: '14px'}}>%</span></p>
                                            <p className="progressPerc bottom">Before</p>
                                        </div>
                                    </Col>
                                    <Col xs={{size: 6}}>
                                        <div className="progressBar after" style={{background: 'linear-gradient(360deg, #56e60d 0%, #56e60d '+afterHeight+'%, #56e60d '+afterHeight+'%, #56e60d 100%)', height: "calc(" + afterHeight + "% - 0px)"}}>
                                            <p className="progressPerc">{feed.afterScore}<span style={{fontSize: '14px'}}>%</span></p>
                                            <p className="progressPerc bottom">After</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </Col>
                    <Col xs={{size: 12}}> 
                        
                        {
                            this.state.isShareIconsVisisble[key] ?

                                <div className="allShareIcons">

                                    <FacebookShareButton
                                        quote={studentName + " used " + hostName + " to learn " + feed.testname + " in " + chapterName}
                                        hashtag={"#"+hostName}
                                        children=""
                                        url={this.state.shareUrl}
                                    >
                                        <FacebookIcon size={26} round={true}></FacebookIcon>
                                    </FacebookShareButton>

                                    <WhatsappShareButton
                                        title={studentName + " used " + hostName + " to learn " + feed.testname + " in " + chapterName + " : "}
                                        separator={" : "}
                                        children=""
                                        url={this.state.shareUrl}
                                    >
                                        <WhatsappIcon size={26} round={true}></WhatsappIcon>
                                    </WhatsappShareButton>

                                    <LinkedinShareButton
                                        title={studentName + " used " + hostName + " to learn " + feed.testname + " in " + chapterName}
                                        // hashtags={["#"+hostName]}
                                        source={window.location.href}
                                        children=""
                                        url={this.state.shareUrl}
                                    >
                                        <LinkedinIcon size={26} round={true}></LinkedinIcon>
                                    </LinkedinShareButton>

                                    <TwitterShareButton
                                        title={studentName + " used " + hostName + " to learn " + feed.testname + " in " + chapterName}
                                        hashtags={["#"+hostName]}
                                        children=""
                                        url={this.state.shareUrl}
                                    >
                                        <TwitterIcon size={26} round={true}></TwitterIcon>
                                    </TwitterShareButton>
                                    
                                    <EmailShareButton
                                        subject={studentName + " used " + hostName + " to learn " + feed.testname + " in " + chapterName}
                                        body={studentName + " used " + hostName + " to learn " + feed.testname + " in " + chapterName}
                                        // hashtags={["#"+hostName]}
                                        children=""
                                        url={this.state.shareUrl}
                                    >
                                        <EmailIcon size={26} round={true}></EmailIcon>
                                    </EmailShareButton>

                                    <FontAwesomeIcon onClick={(e) => this.closeShareButton(key)} className="closeShareButton" icon={faTimes} size="1x" color={"#000"} />

                                </div>

                            : 
                            
                            <Button disabled={this.state.generateImageLoader} className="animated infinite pulse shareButton" color="secondary" size="sm" onClick={e => this.generateImageToShare("autoPopulatedPost"+key)}>
                                <FontAwesomeIcon icon={faShareAlt} size="1x" color={"#fff"} /> &nbsp;Share
                            </Button>
                        }
                    </Col>

                </Row>
            </CardBody>

        </Card>
    )

  }
}

AutoPopulatedFeedResults.propTypes = {
    uploadSharableImageToS3: PropTypes.func.isRequired,
    convertS3ImageToBase64: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    uploadedImageData: state.feedRed.uploadedImageData,
    convertedBase64Binary: state.feedRed.convertedBase64Binary
})

export default connect(mapStateToProps, { uploadSharableImageToS3, convertS3ImageToBase64 })(AutoPopulatedFeedResults);
